export default __webpack_public_path__ + "9bb6094a3c34ba1ed24d1a3866dffc2c.svg";